<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    rounded
    outlined
    dense
    append-icon="mdi-pencil-outline"
    class="outlinedInput"
  />
</template>

<script>

export default {
  name: 'EditOutlinedInput'
}

</script>

<style lang="scss" scoped>
  .outlinedInput {
    & ::v-deep .v-label {
      top: auto;

      &--active {
        top: 10px !important;
      }
    }

    & ::v-deep .v-input__slot {
      padding-right: 8px !important;
    }

    & ::v-deep .v-input__append-inner {
      margin-top: 4px !important;
    }

    & ::v-deep .v-input__icon--append {
      color: #01D28E;
    }
  }
</style>
